'use client';

import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { Typography } from '@/components/ui/typography';

interface Plan {
  name: string;
}

interface WhatIsPlanSectionProps {
  plan: Plan;
  imageSrc?: string;
}

export function WhatIsPlanSection({ plan, imageSrc }: WhatIsPlanSectionProps) {
  const t = useTranslations('planDetails.australianBinaryPlan.whatIsPlan');

  return (
    <SectionWrapper variant="default" padding="md" className="relative bg-gray-50 dark:bg-gray-900/50">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <Typography variant="h2" className="mb-6 text-gray-900 dark:text-white">
              {t('title')}
            </Typography>
            <div className="space-y-6 text-gray-600 dark:text-gray-400 leading-relaxed">
              <Typography variant="p">
                {t('description1')}
              </Typography>
              <Typography variant="p">
                {t('description2')}
              </Typography>
            </div>
          </div>
          <div className="relative">

            <div className="mt-4 md:mt-0 relative w-full">
              <Image
                src={imageSrc || "/images/mlm-plans/mlm-software-demo.webp"}
                alt={t('imageAlt')}
                width={600}
                height={400}
                className="w-full h-full object-contain"
                unoptimized={imageSrc?.toLowerCase().endsWith('.gif')}
              />
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}

